import { useMemo } from 'react';
import { ClusterProperties, PointFeature } from 'supercluster';
import { SearchHitFragment } from '../../generated/graphql';

export interface HitProperties {
    cluster: false;
    hit: SearchHitFragment;
}

export type Properties = HitProperties | ClusterProperties;

const usePoints = (hits: SearchHitFragment[]): PointFeature<Properties>[] =>
    useMemo(
        () =>
            hits.map(hit => {
                const {
                    coordinates: { lon, lat },
                } = hit.rentalUnit.accommodation;

                return {
                    type: 'Feature',
                    id: hit.rentalUnit.id,
                    geometry: {
                        type: 'Point',
                        coordinates: [lon, lat],
                    },
                    properties: {
                        hit,
                        cluster: false,
                    },
                };
            }),
        [hits]
    );

export default usePoints;
